import { createSlice } from '@reduxjs/toolkit';

const initialState = () => ({
  product: null,
  productVariation: null,
  selectedTextureMaterial: null,
  unityLoading: false,
  globalStoreData: null,
  activeStoreInfo: null,
  storeSelectedHotspotList: [],
  storeHoveredSelectedHotspotList: null,
  loading: { loading: false, text: '' },
  isRCPropLoaded: false,
  textureJsonFile: null
});

const retailConfigurator = createSlice({
  name: 'retailConfigurator',
  initialState: initialState(),
  reducers: {
    resetState: () => {
      return initialState();
    },
    setRCProduct: (state, { payload }) => {
      state.product = payload;
      state.productVariation = null;
      state.selectedTextureMaterial = null;
    },
    setRCProductVariation: (state, { payload }) => {
      state.productVariation = payload;
      state.selectedTextureMaterial = null;
    },
    setRCSelectedTextureMaterial: (state, { payload }) => {
      state.selectedTextureMaterial = payload;
    },
    setUnityLoading: (state, { payload }) => {
      state.unityLoading = payload;
    },
    setGlobalStoreData: (state, { payload }) => {
      state.globalStoreData = payload;
    },
    setActiveStoreInfo: (state, { payload }) => {
      state.activeStoreInfo = payload;
    },
    setRCLoading: (state, { payload }) => {
      state.loading = { ...state.loading, ...payload };
    },
    setIsRCPropLoaded: (state, { payload }) => {
      state.isRCPropLoaded = payload;
    },
    setStoreSelectedHotspotList: (state, { payload }) => {
      state.storeSelectedHotspotList = payload;
    },
    setStoreHoveredHotspotList: (state, { payload }) => {
      state.storeHoveredSelectedHotspotList = payload;
    },
    setTextureJsonFile: (state, { payload }) => {
      const { id, data } = payload;
      state.textureJsonFile = {
        ...state.textureJsonFile,
        [id]: data,
      };
    }
  },
});

export const retailConfiguratorActions = retailConfigurator.actions;
export const retailConfiguratorSelector = (state) => state.retailConfigurator;
export const retailConfiguratorReducer = retailConfigurator.reducer;
export default retailConfiguratorReducer;

export const selectRCProduct = (state) => state.retailConfigurator.product;
export const selectTextureJsonFile = (state) => state.retailConfigurator.textureJsonFile;
export const selectRCProductVariation = (state) => state.retailConfigurator.productVariation;
export const selectRCTextureMaterial = (state) => state.retailConfigurator.selectedTextureMaterial;
export const selectIsUnityLoading = (state) => state.retailConfigurator.unityLoading;
export const selectGlobalStoreData = (state) => state.retailConfigurator.globalStoreData;
export const selectActiveStoreInfo = (state) => state.retailConfigurator.activeStoreInfo;
export const selectStoreSelectedHotspotList = (state) => state.retailConfigurator.storeSelectedHotspotList;
export const selectStoreHoveredHotspotList = (state) => state.retailConfigurator.storeHoveredSelectedHotspotList;
export const selectRCLoading = (state) => state.retailConfigurator.loading;
export const selectIsRCPropLoaded = (state) => state.retailConfigurator.isRCPropLoaded;